// The two diplomacy globals, read once per snapshot for the Diplomacy tab.
import type { GameSnapshot } from '@aod/protocol';
import { useMemo } from 'react';
import { type Diplomacy, readDiplomacy } from './diplomacy.js';
import { type Dynasty, readDynasty } from './dynasty.js';

export function useDiplomacyViews(snapshot: GameSnapshot | null): {
  readonly diplomacy: Diplomacy | null;
  readonly dynasty: Dynasty | null;
} {
  const diplomacy = useMemo(() => readDiplomacy(snapshot), [snapshot]);
  const dynasty = useMemo(() => readDynasty(snapshot), [snapshot]);
  return { diplomacy, dynasty };
}
